<template>
    <html>
    <body style="position: relative;background: #fff">
        <section class="section">
            <img src="@/assets/styles/images-link/ban9.png" alt="">
        </section>
        <section class="section container03">
        <div class="da">
            <div class="zuo">
            <h2>系统介绍</h2>
            <h4>SYSTEM INTRODUCTION</h4>
            <p> 农资监管系统根据监管需要和农资市场情况，着重建设两个方面：一方面是农资企业主体备案及企业基础信息采集。另一方面是日常监管、巡查。监管部门通过日常检查与巡检，及时掌握各个可能存在安全隐患和出现问题的环节、节点，从长效机制上实现可追溯制度。实现对农资的全品备案，区域内所有农资经营企业，需通过备案登记系统将企业主体信息、经营产品信息以及资质信息在系统中登记备案，高毒类农药必须严格按照农资及农药等农资登记备案流程进行登记备案并生成对应的二维码，存储至备案库中。实现全程追溯，为农业行政主管部门日常执法提供条件，为农资、农药打假奠定基础，落实农产品质量安全源头监管。</p>
            </div>
        </div>
        </section>
        <section class="section container03 background1" style="">
        <div class="da">
            <div class="zuo">
            <h2 style="color: #39bf3e">门店系统业务场景</h2>
            <h4>Store system business scenario</h4>
            </div>
            <img src="@/assets/styles/images-link/jiang2.png" alt="" > </div>
        </section>
        <section class="section container03">
        <div class="da">
            <div class="zuo">
            <h2>系统案例</h2>
            <h4>System case</h4>
            </div>
            <img src="@/assets/styles/images-link/jiang3.png" alt="" >
            <p>韩城农产品质量安全综合监管服务平台 </p>
        </div>
        </section>       
        
    </body>
</html>
</template>
<style scoped>
    .backgroud1{
        background: url('~@/assets/styles/images-link/jiang1.png') center no-repeat;
        background-size: 100%
    }
</style>

<script>

    import '@/assets/styles/css/zhihui1.css';   
    export default {
        name: '',
        components: {},
        data: () => {
            return {

            };
        },
        created() {
            let wintitle = `${window.document.title}`;
            let title = wintitle.split('-')
            window.document.title = '农资监管系统 - ' + title[1];
        },

        methods: {

        },
    }
</script>
